import React from 'react';
import ContentPage from '../ContentPage/ContentPage';

const PaymentPage: React.FC = () => <ContentPage slug="zahlung" title="Zahlung" />;

export default PaymentPage;
